import { Config } from "./Config.js";

export const ApiService = {
    getEvent(eventId, program) {
        return fetch(`${Config.get("apiUrl")}/event/${eventId}?program=${program}`);
    },

    getDiscount(eventId, promoCode) {
        return fetch(`${Config.get("apiUrl")}/event/${eventId}/discount/${promoCode}`);
    },

    getTickets(orderNumber) {
        return fetch(`${Config.get("apiUrl")}/tickets/${orderNumber}`);
    },

    createSession(cartData) {
        return fetch(`${Config.get("apiUrl")}/session`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(cartData)
        });
    },

    getStripeKey() {
        return fetch(`${Config.get("apiUrl")}/config/key`);
    },
};
